export default __webpack_public_path__ + "static/media/bg.23f0b793.jpg";